// copiato da src/components/solitario/TutorialSolitario.tsx:182-226 @ cad51507af021388ceb3a5de34eb61259665077d (`Scheda`), cosi` com'e`.
import { useLayoutEffect, useRef, useState } from 'react';
import type { ReactNode } from 'react';

import { cn } from '@/lib/cn';

/**
 * Una scheda dello strato (apertura, riepilogo): se non ci sta scorre dentro di se`, e una sfumatura in fondo dice che sotto c'e` altro (`data-altro-sotto`), finche` non si e` arrivati in fondo.
 * La misura si ripete a ogni scorrimento e a ogni cambio di misura del contenuto (il carattere display arriva dopo il primo disegno).
 */
export function Scheda({ children, piede, className }: { children: ReactNode; piede?: ReactNode; className?: string }) {
  const scorre = useRef<HTMLDivElement | null>(null);
  const contenuto = useRef<HTMLDivElement | null>(null);
  const [altroSotto, setAltroSotto] = useState(false);
  useLayoutEffect(() => {
    const el = scorre.current;
    if (el === null) return;
    const misura = () => setAltroSotto(el.scrollHeight - el.scrollTop - el.clientHeight > 1);
    misura();
    el.addEventListener('scroll', misura, { passive: true });
    const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(misura) : null;
    ro?.observe(el);
    if (contenuto.current !== null) ro?.observe(contenuto.current);
    return () => {
      el.removeEventListener('scroll', misura);
      ro?.disconnect();
    };
  }, []);
  return (
    <div className={cn('flex max-h-full min-h-0 w-full flex-col overflow-hidden rounded-2xl border border-border bg-bg-secondary', className)}>
      <div className="relative flex min-h-0 flex-1 flex-col">
        <div ref={scorre} className="min-h-0 flex-1 overflow-y-auto p-4 [touch-action:pan-y]">
          <div ref={contenuto} className="flex flex-col gap-3">
            {children}
          </div>
        </div>
        {altroSotto && <span data-altro-sotto aria-hidden="true" className="pointer-events-none absolute inset-x-0 bottom-0 h-10 bg-gradient-to-t from-bg-secondary to-transparent" />}
      </div>
      {piede !== undefined && <div className="flex shrink-0 gap-2 px-4 pb-4 pt-1">{piede}</div>}
    </div>
  );
}
